import checkoutFormModel from "./checkoutFormModel";

import {
  validateEmail,
  validateRequired,
  validateForLength,
} from "../../validation";

const {
  formField: {
    firstName,
    lastName,
    address,
    postCode,
    city,
    telephone,
    email,
    country,
    shipping,
  },
} = checkoutFormModel;

export const firstStepRequiredFields = [
  firstName.name,
  lastName.name,
  address.name,
  postCode.name,
  city.name,
  telephone.name,
  email.name,
  country.name,
];

const validation = [
  (values) => {
    let errors = {};
    const { [firstName.name]: nameVal, [lastName.name]: lastNameVal, ...otherValues } = values;
    
    validateForLength({ values: otherValues, errors });
    validateForLength({ values: { [firstName.name]: nameVal, [lastName.name]: lastNameVal }, errors, maxLength: 49 });

    firstStepRequiredFields.forEach((item) => {
      const errMsg = validateRequired(values[item]);
      if (errMsg) {
        errors[item] = errMsg;
      }
    });

    const errMsg = validateEmail(values[email.name]);
    if (errMsg) {
      errors[email.name] = errMsg;
    }

    // if one of shipping address fields filled in
    // make sure all fields filled in
    const shippingFields = Object.values(shipping).map((item) => item.name);
    const {
      shippingAddress2,
      shippingPhone,
      shippingEmail,
      ...otherShippingFields
    } = shipping;
    const requiredShippingFields = Object.values(otherShippingFields).map(
      (item) => item.name
    );

    const needCheckShippingFields = Boolean(
      shippingFields.find((item) => !!values[item])
    );

    if (needCheckShippingFields) {
      requiredShippingFields.forEach((item) => {
        const errMsg = validateRequired(values[item]);
        if (errMsg) {
          errors[item] = errMsg;
        }
      });

      const errMsg = validateEmail(values[shipping.shippingEmail.name]);
      if (errMsg) {
        errors[shipping.shippingEmail.name] = errMsg;
      }
    }

    return errors;
  },
  () => ({}),
  () => {
    // validation for 3d step
    return {};
  },
  () => ({}),
];

export default validation;
